import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Gallery", href: "#gallery" },
  { label: "Visit", href: "#visit" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-sand-50/85 backdrop-blur-xl border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <a href="#top" data-testid="header-logo" className="flex flex-col leading-none">
            <img
              src="/flavios-logo.png"
              alt="Flavio's"
              className="h-12 lg:h-16 w-auto object-contain"
            />
            <span className="text-[0.6rem] tracking-[0.3em] uppercase text-ink-500 mt-1">
              House of Hair
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-10">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className="text-sm tracking-[0.15em] uppercase text-ink-700 hover:text-gold transition-colors duration-300"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-3">
            <a
              href="tel:+19058222690"
              data-testid="header-call-btn"
              className="hidden sm:inline-flex items-center gap-2 text-sm tracking-[0.12em] uppercase text-ink-900 hover:text-gold transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="font-medium">(905) 822-2690</span>
            </a>

            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden p-2 text-ink-900"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div data-testid="mobile-nav-drawer" className="lg:hidden bg-sand-50 border-t border-black/5">
          <nav className="px-6 py-8 flex flex-col gap-6">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className="font-serif text-3xl text-ink-900 hover:text-gold transition-colors"
              >
                {item.label}
              </a>
            ))}
            <a
              href="tel:+19058222690"
              data-testid="mobile-call-btn"
              className="btn-primary mt-4 w-fit"
            >
              <Phone className="w-4 h-4" /> Call Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
